import React, { Component } from "react";
import Logout from "../../assets/logout.svg";
import setting from "../../assets/setting.svg";
import Back from "../../assets/back.svg";
import buycondition from "../../assets/buycondition.png";
import customergroup from "../../assets/customergroup.png";
import Polls from "../../assets/Polls.png";
import reports from "../../assets/reports.png";
import DashboardItem from "../../components/DashboardItem";
import Loading from "../../components/Loading";
import { Modal, Form } from "react-bootstrap";
// import Profile from './Profile'
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { NumericFormat } from "react-number-format";
import Cancel from "../../assets/cancel.svg";
import Tick from "../../assets/tick.svg";
import CustomButton from "../../components/CustomButton";
import { WhisperSpinner } from "react-spinners-kit";
import events from "../../assets/events.png";
import messages from "../../assets/messages.png";
import { toast } from "react-toastify";
import {
  BaseUrl,
  Authorization,
  isUser,
  LogoutFunction,
  ClubAuthorization,
} from "../../static.js";
import "../../App1.css";
import Tooltip from "@mui/material/Tooltip";

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      resName: "",
      resDescription: "",
      resID: null,
      notFound: false,
      ModalShow: false,
      minTimeErrorText: "",
      minTimeValue: "",
      minCreditErrorText: "",
      minCreditValue: "",
      GTimeSpanErrorText: "",
      GTimeSpanValue: "",
      minCreditRememberErrorText: "",
      minCreditRememberValue: "",
      minDateRememberErrorText: "",
      minDateRememberValue: "",
      rememberCredit: false,
      websiteValue: "",
      instagramValue: "",
      resStatus: false,
      applyCredit: false,
      pollStatus: false,
      minPollPurchaseErrorText: "",
      minPollPurchaseValue: "",
      minPollTime0ErrorText: "",
      minPollTime0Value: "",
      minPollTime1ErrorText: "",
      minPollTime1Value: "",
      minPollTime2ErrorText: "",
      minPollTime2Value: "",
      useName: "",
      smsAfter: false,
      resNameValue: "",
      loadingSetting: true,
      writingSetting: false,
      suspectMinPurchaseCountDay: "",
      suspectMinPurchaseCountWeek: "",
      suspectMinPurchaseCountMonth: "",
      blockMinPurchaseCountDay: "",
      blockMinPurchaseCountWeek: "",
      blockMinPurchaseCountMonth: "",
      susblockError1: "",
      susblockError2: "",
      susblockError3: "",
    };

    this.textHandleChange = this.textHandleChange.bind(this);
    this.getRestaurantSetting = this.getRestaurantSetting.bind(this);
    this.minTimeInput = React.createRef();
    this.GTimeSpanInput = React.createRef();
    this.minDateRememberInput = React.createRef();
  }

  getBusinessInfo() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        // console.log(result);
        if (result.status === 200) {
          let name = "";
          result.info.forEach((element) => {
            if (element.languageId === 1) {
              name = element.name;
            }
          });

          if (name === "") {
            result.info.forEach((element) => {
              if (element.languageId === result.result[0].defaultLanguage) {
                name = element.name;
              }
            });
          }

          if (name === "") {
            result.info.forEach((element) => {
              if (name === "") {
                name = element.name;
              }
            });
          }

          this.setState(
            { currentRestaurantId: result.result[0].id, resName: name },
            () => {
              if (!this.state.loading) this.getRestaurantSetting();
              else this.setState({ loading: false });
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        }
        // console.log("findBusinessWithCode:", result);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    // this.setState({
    //   loading: false,
    //   resID: this.props.match.params.id,
    //   // resName: "باشگاه مشتریان",
    // });
    this.getBusinessInfo();
  }

  onBack() {
    this.props.history.push("/Restaurants/" + this.props.match.params.id);
  }

  onRulesPurchaseClick() {
    this.props.onRulesPurchaseClick(this.props.match.params.id);
  }

  onCustomerGroupsClick() {
    // alert("0");
    this.props.onCustomerGroupsClick(this.props.match.params.id);
  }

  onPollsClick() {
    this.props.onPollsClick(this.props.match.params.id);
  }

  onReportsClick() {
    this.props.onReportsClick(this.props.match.params.id);
  }

  onMessagePatternsClick() {
    this.props.onMessagePatterns(this.props.match.params.id);
  }

  onEventsClick() {
    this.props.onEvents(this.props.match.params.id);
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  onLogout() {
    LogoutFunction();
  }

  onSetting() {
    this.getBusinessInfo();
  }

  getRestaurantSetting() {
    this.setState({ loadingSetting: true, ModalShow: true });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/Restaurant/GetRestaurantSetting?restaurantId=" +
        this.state.currentRestaurantId,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log(result);
        if (result.isSuccessfull) {
          this.setState({
            loadingSetting: false,
            resStatus: result.results[0].isActive,
            minTimeValue: result.results[0].minTimeForSendingCode
              ? result.results[0].minTimeForSendingCode
              : "",
            minCreditValue: result.results[0].minCredit
              ? result.results[0].minCredit
              : "",
            applyCredit: result.results[0].applyCreditToDiscountInvoice,
            GTimeSpanValue: result.results[0].memberGroupTimeSpanMonth
              ? result.results[0].memberGroupTimeSpanMonth
              : "",
            rememberCredit: result.results[0].rememberCreditExpiration
              ? result.results[0].rememberCreditExpiration
              : "",
            minCreditRememberValue: result.results[0].minCreditRemember
              ? result.results[0].minCreditRemember
              : "",
            minDateRememberValue: result.results[0].minDateRemember
              ? result.results[0].minDateRemember
              : "",
            websiteValue: result.results[0].webSiteURL
              ? result.results[0].webSiteURL
              : "",
            instagramValue: result.results[0].instagramId
              ? result.results[0].instagramId
              : "",
            pollStatus:
              result.results[0].isPollEnable === null
                ? false
                : result.results[0].isPollEnable,
            minPollPurchaseValue: result.results[0].pollMinPurchase
              ? result.results[0].pollMinPurchase
              : "",
            minPollTime0Value: result.results[0].pollMinTimeService0
              ? result.results[0].pollMinTimeService0
              : "",
            minPollTime1Value: result.results[0].pollMinTimeService1
              ? result.results[0].pollMinTimeService1
              : "",
            minPollTime2Value: result.results[0].pollMinTimeService2
              ? result.results[0].pollMinTimeService2
              : "",
            useName: result.results[0].pollUseRestaurantNameInSMS
              ? result.results[0].pollUseRestaurantNameInSMS
              : "",
            smsAfter: result.results[0].pollTextAfterSubmiting
              ? result.results[0].pollTextAfterSubmiting
              : "",
            resNameValue: result.results[0].name ? result.results[0].name : "",
            suspectMinPurchaseCountDay: result.results[0]
              .suspectMinPurchaseCountDay
              ? result.results[0].suspectMinPurchaseCountDay
              : "",
            suspectMinPurchaseCountWeek: result.results[0]
              .suspectMinPurchaseCountWeek
              ? result.results[0].suspectMinPurchaseCountWeek
              : "",
            suspectMinPurchaseCountMonth: result.results[0]
              .suspectMinPurchaseCountMonth
              ? result.results[0].suspectMinPurchaseCountMonth
              : "",
            blockMinPurchaseCountDay: result.results[0].blockMinPurchaseCountDay
              ? result.results[0].blockMinPurchaseCountDay
              : "",
            blockMinPurchaseCountWeek: result.results[0]
              .blockMinPurchaseCountWeek
              ? result.results[0].blockMinPurchaseCountWeek
              : "",
            blockMinPurchaseCountMonth: result.results[0]
              .blockMinPurchaseCountMonth
              ? result.results[0].blockMinPurchaseCountMonth
              : "",
          });
        } else {
          this.props.history.push("/Restaurants");
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingSetting: false, ModalShow: false });
      });
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onSaveSetting() {
    if (this.state.resStatus !== true && this.state.resStatus !== false) {
      this.setState({ resStatus: false });
    }

    if (!this.state.minTimeValue || isNaN(this.state.minTimeValue)) {
      this.setState(
        { minTimeErrorText: "حداقل فاصله زمانی باید عدد کمتر از 255 باشد" },
        () => {
          toast.error(this.state.minTimeErrorText, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ minTimeErrorText: "" });
    }

    if (!this.state.minCreditValue || isNaN(this.state.minCreditValue)) {
      this.setState(
        { minCreditErrorText: "حداقل اعتبار باید یک عدد باشد" },
        () => {
          toast.error(this.state.minCreditErrorText, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ minCreditErrorText: "" });
    }

    if (!this.state.GTimeSpanValue || isNaN(this.state.GTimeSpanValue)) {
      this.setState(
        {
          GTimeSpanErrorText:
            "دوره زمانی برای محاسبه گروه‌ها باید عدد کمتر از 255 باشد",
        },
        () => {
          toast.error(this.state.GTimeSpanErrorText, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ GTimeSpanErrorText: "" });
    }

    if (!this.state.resNameValue) {
      this.setState(
        { resNameErrorText: "نام رستوران نمی‌تواند خالی باشد" },
        () => {
          toast.error(this.state.resNameErrorText, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ resNameErrorText: "" });
    }

    if (
      this.state.suspectMinPurchaseCountDay &&
      Number(this.state.suspectMinPurchaseCountDay) >=
        Number(this.state.blockMinPurchaseCountDay)
    ) {
      this.setState(
        {
          susblockError1:
            "فیلد مسدود به ثبت خريد زياد در روز باید بیشتر از فیلد مشکوک به ثبت خريد زياد در روز باشد",
        },
        () => {
          toast.error(this.state.susblockError1, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ susblockError1: "" });
    }

    if (
      this.state.suspectMinPurchaseCountWeek &&
      Number(this.state.suspectMinPurchaseCountWeek) >=
        Number(this.state.blockMinPurchaseCountWeek)
    ) {
      this.setState(
        {
          susblockError2:
            "فیلد مسدود به ثبت خريد زياد در هفته باید بیشتر از فیلد مشکوک به ثبت خريد زياد در هفته باشد",
        },
        () => {
          toast.error(this.state.susblockError2, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ susblockError2: "" });
    }

    if (
      this.state.suspectMinPurchaseCountMonth &&
      Number(this.state.suspectMinPurchaseCountMonth) >=
        Number(this.state.blockMinPurchaseCountMonth)
    ) {
      this.setState(
        {
          susblockError3:
            "فیلد مسدود به ثبت خريد زياد در ماه باید بیشتر از فیلد مشکوک به ثبت خريد زياد در ماه باشد",
        },
        () => {
          toast.error(this.state.susblockError3, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ susblockError3: "" });
    }

    let data = {
      IsActive: this.state.resStatus,
      MinTimeForSendingCode: this.state.minTimeValue,
      MinCredit: this.state.minCreditValue,
      ApplyCreditToDiscountInvoice: this.state.applyCredit,
      MemberGroupTimeSpanMonth: this.state.GTimeSpanValue,
      RememberCreditExpiration: this.state.rememberCredit,
      MinCreditRemember: this.state.minCreditRememberValue,
      MinDateRemember: this.state.minDateRememberValue,
      WebSiteURL: this.state.websiteValue,
      InstagramId: this.state.instagramValue,
      IsPollEnable: this.state.pollStatus,
      PollMinPurchase: this.state.minPollPurchaseValue,
      PollMinTimeService0: this.state.minPollTime0Value,
      PollMinTimeService1: this.state.minPollTime1Value,
      PollMinTimeService2: this.state.minPollTime2Value,
      PollUseRestaurantNameInSMS: this.state.useName,
      PollTextAfterSubmiting: this.state.smsAfter,
      Name: this.state.resNameValue,
      RestaurantId: this.state.currentRestaurantId,
      suspectMinPurchaseCountDay: this.state.suspectMinPurchaseCountDay,
      suspectMinPurchaseCountWeek: this.state.suspectMinPurchaseCountWeek,
      suspectMinPurchaseCountMonth: this.state.suspectMinPurchaseCountMonth,
      blockMinPurchaseCountDay: this.state.blockMinPurchaseCountDay,
      blockMinPurchaseCountWeek: this.state.blockMinPurchaseCountWeek,
      blockMinPurchaseCountMonth: this.state.blockMinPurchaseCountMonth,
    };
    console.log(data);
    this.setState({ writingSetting: true });

    let data1 = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data1 = Object.assign(data1, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data1));

    fetch("https://94.101.187.196/api/Restaurant/UpdateRestaurantSetting", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: jsonString,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.isSuccessfull) {
          this.setState({ resName: this.state.resNameValue });
          toast.success("تنظیمات با موفقیت ذخیره شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          this.setState({ writingSetting: false, ModalShow: false });
        } else if (result.errorMessage) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          this.setState({ writingSetting: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ writingSetting: false });
      });
  }

  render() {
    if (!this.state.loading) {
      return (
        <div className="Login">
          <div className="header">
            <div
              onClick={this.onBack.bind(this)}
              className="linkStyle backButton"
            >
              <img
                src={Back}
                alt=""
                className="backButtonIcon"
                style={{ transform: "rotate(180deg)" }}
              />
              بازگشت
            </div>
            {/* <div onClick={this.onLogout.bind(this)} className="linkStyle backButton"><img src={Logout} alt="" className="backButtonIcon" />Logout</div> */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                height: "fit-content",
                alignItems: "center",
              }}
            >
              {!isUser && (
                <Tooltip title="تنظیمات">
                  <div
                    onClick={this.onSetting.bind(this)}
                    className="linkStyle backButton"
                    // data-tip="تنظیمات"
                    // data-place="right"
                  >
                    <img src={setting} alt="" className="backButtonIcon" />
                  </div>
                </Tooltip>
              )}
              <div
                style={{
                  height: "20px",
                  minWidth: "1px",
                  backgroundColor: "var(--brown1)",
                  margin: "0px 5px",
                }}
              />
              <Tooltip title="خروج">
                <div
                  onClick={this.onLogout.bind(this)}
                  className="linkStyle backButton"
                >
                  <img src={Logout} alt="" className="backButtonIcon" />
                </div>
              </Tooltip>
            </div>
          </div>
          <div className="LoginContent">
            <div className="RestaurantsListTitle">باشگاه مشتریان</div>
            <div className="RestaurantsListSubTitle">{this.state.resName}</div>
          </div>
          <div
            style={{ minHeight: "30px", height: "8vh", maxHeight: "60px" }}
          />
          <div className="dashboardContent">
            <div
              style={{
                flex: "1",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="menu-grid">
                <DashboardItem
                  img={customergroup}
                  title="گروه‌بندی مشترکین"
                  onClick={this.onCustomerGroupsClick.bind(this)}
                />
                <DashboardItem
                  img={buycondition}
                  title="شروط خرید"
                  onClick={this.onRulesPurchaseClick.bind(this)}
                />
                <DashboardItem
                  img={Polls}
                  title="نظرسنجی"
                  onClick={this.onPollsClick.bind(this)}
                />
                <DashboardItem
                  img={reports}
                  title="گزارشات"
                  onClick={this.onReportsClick.bind(this)}
                />
                <DashboardItem
                  img={messages}
                  title="الگوهای پیام"
                  onClick={this.onMessagePatternsClick.bind(this)}
                />
                <DashboardItem
                  img={events}
                  title="رویدادها"
                  onClick={this.onEventsClick.bind(this)}
                />
              </div>
            </div>
            <div style={{ flex: "2" }} />
          </div>
          <Modal
            show={this.state.ModalShow}
            size="lg"
            animation={true}
            onHide={this.hideModal.bind(this)}
            centered
          >
            {this.state.loadingSetting && (
              <div
                style={{
                  width: "100%",
                  minHeight: "100px",
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <WhisperSpinner
                  size={30}
                  color="var(--brown1)"
                  frontColor="var(--brown1)"
                  backColor="var(--brown1)"
                  loading={true}
                />
              </div>
            )}
            {!this.state.loadingSetting && (
              <div className="settingContainer">
                <div className="ModalTitle">تنظیمات باشگاه مشتریان</div>
                {/* <div className="ModalSubTitle">{this.state.resName}</div> */}

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    overflow: "auto",
                    marginTop: "20px",
                    padding: "5px",
                    width: "100%",
                  }}
                >
                  <div className="settingItemContainer">
                    <div className="settingLabel">
                      نام رستوران (برای نمایش در پیامک)
                    </div>
                    <Form.Control
                      maxLength="50"
                      className="inputStyleForm textAlignCenter"
                      style={{ maxWidth: "250px" }}
                      placeholder="نام"
                      type="text"
                      name="resNameValue"
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.resNameValue}
                    />
                  </div>
                  <div className="settingItemContainer">
                    <div className="settingLabel">وضعیت</div>
                    <BootstrapSwitchButton
                      checked={this.state.resStatus}
                      onChange={(checked) => {
                        this.setState({ resStatus: checked });
                      }}
                      onlabel="فعال"
                      offlabel="غیرفعال"
                      onstyle="primary"
                      offstyle="warning"
                      width={75}
                    />
                  </div>
                  <div className="settingItemContainer">
                    <div className="settingLabel">
                      حداقل فاصله زمانی برای ارسال کد (ساعت)
                    </div>
                    <Form.Control
                      maxLength="3"
                      className={
                        this.state.minTimeErrorText !== ""
                          ? "inputStyleForm inputError textAlignCenter"
                          : "inputStyleForm textAlignCenter"
                      }
                      style={{ maxWidth: "70px", direction: "ltr" }}
                      placeholder="ساعت"
                      type="text"
                      name="minTimeValue"
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.minTimeValue}
                    />
                  </div>
                  <div className="settingItemContainer">
                    <div className="settingLabel">
                      حداقل اعتبار قابل استفاده (ریال)
                    </div>
                    <NumericFormat
                      className={
                        this.state.minCreditErrorText !== ""
                          ? "inputStyleForm inputError textAlignCenter form-control"
                          : "form-control inputStyleForm textAlignCenter"
                      }
                      style={{ maxWidth: "120px", direction: "ltr" }}
                      placeholder="ریال"
                      type="text"
                      name="minCreditValue"
                      onValueChange={(values) => {
                        this.setState({ minCreditValue: values.value });
                      }}
                      value={this.state.minCreditValue}
                      allowNegative={true}
                      displayType={"input"}
                      thousandSeparator={true}
                    />
                  </div>
                  <div className="settingItemContainer">
                    <div className="settingLabel">
                      آيا به فاکتورهايی که شامل تخفيف بوده اعتبار باشگاه تعلق
                      گيرد؟
                    </div>
                    <BootstrapSwitchButton
                      checked={this.state.applyCredit}
                      onChange={(checked) => {
                        this.setState({ applyCredit: checked });
                      }}
                      onlabel="بله"
                      offlabel="خیر"
                      onstyle="primary"
                      offstyle="warning"
                      width={75}
                    />
                  </div>
                  <div className="settingItemContainer">
                    <div className="settingLabel">
                      دوره زمانی برای محاسبه گروه‌ها (ماه)
                    </div>
                    <Form.Control
                      maxLength="3"
                      className={
                        this.state.GTimeSpanErrorText !== ""
                          ? "inputStyleForm inputError textAlignCenter"
                          : "inputStyleForm textAlignCenter"
                      }
                      style={{ maxWidth: "70px", direction: "ltr" }}
                      placeholder="ماه"
                      type="text"
                      name="GTimeSpanValue"
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.GTimeSpanValue}
                      ref={this.GTimeSpanInput}
                    />
                  </div>
                  <div
                    className="settingItemContainer"
                    style={{
                      flexDirection: "column",
                      justifyContent: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div className="settingLabel">
                        یادآوری در زمان انقضاء اعتبار
                      </div>
                      <BootstrapSwitchButton
                        checked={this.state.rememberCredit}
                        onChange={(checked) => {
                          this.setState({ rememberCredit: checked });
                        }}
                        onlabel="فعال"
                        offlabel="غیرفعال"
                        onstyle="primary"
                        offstyle="warning"
                        width={75}
                      />
                    </div>

                    {this.state.rememberCredit && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "10px",
                        }}
                      >
                        <div
                          className="settingLabel"
                          style={{ fontSize: "12px" }}
                        >
                          حداقل اعتبار برای یادآوری (ریال)
                        </div>
                        <NumericFormat
                          className={
                            this.state.minCreditRememberErrorText !== ""
                              ? "inputStyleForm inputError textAlignCenter form-control"
                              : "form-control inputStyleForm textAlignCenter"
                          }
                          style={{ maxWidth: "120px", direction: "ltr" }}
                          placeholder="ريال"
                          type="text"
                          name="minCreditRememberValue"
                          onValueChange={(values) => {
                            this.setState({
                              minCreditRememberValue: values.value,
                            });
                          }}
                          value={this.state.minCreditRememberValue}
                          allowNegative={true}
                          displayType={"input"}
                          thousandSeparator={true}
                        />
                      </div>
                    )}

                    {this.state.rememberCredit && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "10px",
                        }}
                      >
                        <div
                          className="settingLabel"
                          style={{ fontSize: "12px" }}
                        >
                          چند روز قبل از انقضاء
                        </div>
                        <Form.Control
                          maxLength="3"
                          className={
                            this.state.minDateRememberErrorText !== ""
                              ? "inputStyleForm inputError textAlignCenter"
                              : "inputStyleForm textAlignCenter"
                          }
                          style={{ maxWidth: "70px", direction: "ltr" }}
                          placeholder="روز"
                          type="text"
                          name="minDateRememberValue"
                          onChange={this.textHandleChange.bind(this)}
                          value={this.state.minDateRememberValue}
                          ref={this.minDateRememberInput}
                        />
                      </div>
                    )}
                  </div>
                  <div className="settingItemContainer">
                    <div className="settingLabel">آدرس وب سایت</div>
                    <Form.Control
                      className="inputStyleForm textAlignCenter"
                      style={{ maxWidth: "250px", direction: "ltr" }}
                      placeholder="وب سایت"
                      type="text"
                      name="websiteValue"
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.websiteValue}
                    />
                  </div>
                  <div className="settingItemContainer">
                    <div className="settingLabel">آدرس اینستاگرام</div>
                    <Form.Control
                      className="inputStyleForm textAlignCenter"
                      style={{ maxWidth: "250px", direction: "ltr" }}
                      placeholder="اینستاگرام"
                      type="text"
                      name="instagramValue"
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.instagramValue}
                    />
                  </div>
                  <div className="settingItemContainer">
                    <div className="settingLabel">آیا نظرسنجی فعال باشد؟</div>
                    <BootstrapSwitchButton
                      checked={this.state.pollStatus}
                      onChange={(checked) => {
                        this.setState({ pollStatus: checked });
                      }}
                      onlabel="فعال"
                      offlabel="غیرفعال"
                      onstyle="primary"
                      offstyle="warning"
                      width={75}
                    />
                  </div>
                  <div className="settingItemContainer">
                    <div className="settingLabel">
                      حداقل مبلغ خريد برای ارسال نظرسنجی (ریال)
                    </div>
                    <NumericFormat
                      className={
                        this.state.minPollPurchaseErrorText !== ""
                          ? "inputStyleForm inputError textAlignCenter form-control"
                          : "form-control inputStyleForm textAlignCenter"
                      }
                      style={{ maxWidth: "120px", direction: "ltr" }}
                      placeholder="ريال"
                      type="text"
                      name="minPollPurchaseValue"
                      onValueChange={(values) => {
                        this.setState({ minPollPurchaseValue: values.value });
                      }}
                      value={this.state.minPollPurchaseValue}
                      allowNegative={true}
                      displayType={"input"}
                      thousandSeparator={true}
                    />
                  </div>
                  <div className="settingItemContainer">
                    <div className="settingLabel">
                      ميزان تاخير برای سرويس داخلی (دقیقه)
                    </div>
                    <Form.Control
                      maxLength="3"
                      className={
                        this.state.minPollTime0ErrorText !== ""
                          ? "inputStyleForm inputError textAlignCenter"
                          : "inputStyleForm textAlignCenter"
                      }
                      style={{ maxWidth: "70px", direction: "ltr" }}
                      placeholder="دقیقه"
                      type="text"
                      name="minPollTime0Value"
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.minPollTime0Value}
                      // ref={this.minDateRememberInput}
                    />
                  </div>
                  <div className="settingItemContainer">
                    <div className="settingLabel">
                      ميزان تاخير برای سرويس بسته بندی (دقیقه)
                    </div>
                    <Form.Control
                      maxLength="3"
                      className={
                        this.state.minPollTime1ErrorText !== ""
                          ? "inputStyleForm inputError textAlignCenter"
                          : "inputStyleForm textAlignCenter"
                      }
                      style={{ maxWidth: "70px", direction: "ltr" }}
                      placeholder="دقیقه"
                      type="text"
                      name="minPollTime1Value"
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.minPollTime1Value}
                      // ref={this.minDateRememberInput}
                    />
                  </div>
                  <div className="settingItemContainer">
                    <div className="settingLabel">
                      ميزان تاخير برای سرويس ارسال (دقیقه)
                    </div>
                    <Form.Control
                      maxLength="3"
                      className={
                        this.state.minPollTime2ErrorText !== ""
                          ? "inputStyleForm inputError textAlignCenter"
                          : "inputStyleForm textAlignCenter"
                      }
                      style={{ maxWidth: "70px", direction: "ltr" }}
                      placeholder="دقیقه"
                      type="text"
                      name="minPollTime2Value"
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.minPollTime2Value}
                    />
                  </div>
                  <div className="settingItemContainer">
                    <div className="settingLabel">
                      استفاده از نام شعبه در پیام
                    </div>
                    <BootstrapSwitchButton
                      checked={this.state.useName}
                      onChange={(checked) => {
                        this.setState({ useName: checked });
                      }}
                      onlabel="بله"
                      offlabel="خیر"
                      onstyle="primary"
                      offstyle="warning"
                      width={75}
                    />
                  </div>
                  <div className="settingItemContainer">
                    <div className="settingLabel">
                      بعد از نظرسنجی پیام ارسال شود؟
                    </div>
                    <BootstrapSwitchButton
                      checked={this.state.smsAfter}
                      onChange={(checked) => {
                        this.setState({ smsAfter: checked });
                      }}
                      onlabel="بله"
                      offlabel="خیر"
                      onstyle="primary"
                      offstyle="warning"
                      width={75}
                    />
                  </div>

                  <div className="settingItemContainer">
                    <div className="settingLabel">
                      مشکوک به ثبت خريد زياد در روز (چندبار)
                    </div>
                    <Form.Control
                      maxLength="3"
                      className="inputStyleForm textAlignCenter"
                      style={{ maxWidth: "70px", direction: "ltr" }}
                      placeholder="روز"
                      type="text"
                      name="suspectMinPurchaseCountDay"
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.suspectMinPurchaseCountDay}
                    />
                  </div>

                  <div className="settingItemContainer">
                    <div className="settingLabel">
                      مشکوک به ثبت خريد زياد در هفته (چندبار)
                    </div>
                    <Form.Control
                      maxLength="3"
                      className="inputStyleForm textAlignCenter"
                      style={{ maxWidth: "70px", direction: "ltr" }}
                      placeholder="هفته"
                      type="text"
                      name="suspectMinPurchaseCountWeek"
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.suspectMinPurchaseCountWeek}
                    />
                  </div>

                  <div className="settingItemContainer">
                    <div className="settingLabel">
                      مشکوک به ثبت خريد زياد در ماه (چندبار)
                    </div>
                    <Form.Control
                      maxLength="3"
                      className="inputStyleForm textAlignCenter"
                      style={{ maxWidth: "70px", direction: "ltr" }}
                      placeholder="ماه"
                      type="text"
                      name="suspectMinPurchaseCountMonth"
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.suspectMinPurchaseCountMonth}
                    />
                  </div>

                  <div className="settingItemContainer">
                    <div className="settingLabel">
                      مسدود به ثبت خريد زياد در روز (چندبار)
                    </div>
                    <Form.Control
                      maxLength="3"
                      className={
                        this.state.susblockError1 !== ""
                          ? "inputStyleForm inputError textAlignCenter"
                          : "inputStyleForm textAlignCenter"
                      }
                      // className="inputStyleForm textAlignCenter"
                      style={{ maxWidth: "70px", direction: "ltr" }}
                      placeholder="روز"
                      type="text"
                      name="blockMinPurchaseCountDay"
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.blockMinPurchaseCountDay}
                    />
                  </div>

                  <div className="settingItemContainer">
                    <div className="settingLabel">
                      مسدود به ثبت خريد زياد در هفته (چندبار)
                    </div>
                    <Form.Control
                      maxLength="3"
                      className={
                        this.state.susblockError2 !== ""
                          ? "inputStyleForm inputError textAlignCenter"
                          : "inputStyleForm textAlignCenter"
                      }
                      style={{ maxWidth: "70px", direction: "ltr" }}
                      placeholder="هفته"
                      type="text"
                      name="blockMinPurchaseCountWeek"
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.blockMinPurchaseCountWeek}
                    />
                  </div>

                  <div className="settingItemContainer">
                    <div className="settingLabel">
                      مسدود به ثبت خريد زياد در ماه (چندبار)
                    </div>
                    <Form.Control
                      maxLength="3"
                      className={
                        this.state.susblockError2 !== ""
                          ? "inputStyleForm inputError textAlignCenter"
                          : "inputStyleForm textAlignCenter"
                      }
                      style={{ maxWidth: "70px", direction: "ltr" }}
                      placeholder="ماه"
                      type="text"
                      name="blockMinPurchaseCountMonth"
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.blockMinPurchaseCountMonth}
                    />
                  </div>
                </div>

                <div
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: "20px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ flex: "1" }}>
                    <CustomButton
                      title="ذخیره"
                      loading={this.state.writingSetting}
                      imgHeight={20}
                      imgWidth={25}
                      minHeight="35px"
                      img={Tick}
                      onClick={this.onSaveSetting.bind(this)}
                    />
                  </div>
                  <div style={{ minWidth: "10px" }} />
                  <div style={{ flex: "0.8" }}>
                    <CustomButton
                      title="انصراف"
                      imgHeight={19}
                      backColor="var(--black1)"
                      imgWidth={25}
                      minHeight="35px"
                      img={Cancel}
                      onClick={this.hideModal.bind(this)}
                    />
                  </div>
                </div>
              </div>
            )}
          </Modal>
          {/* <ReactTooltip effect="solid" /> */}
        </div>
      );
    } else {
      if (this.state.notFound) {
        return null;
      } else {
        return <Loading />;
      }
    }
  }
}
